export default __webpack_public_path__ + "static/media/organic-logo.b4db0085.png";